/* eslint-disable no-use-before-define */
import { Grid, Link, Theme, Typography, withStyles } from '@material-ui/core'
import { TFunction } from 'i18next'
import CheckCircleIcon from 'mdi-react/CheckCircleIcon'
import { isMobile } from 'react-device-detect'
import DownloadIcon from '../../../images/Download.svg'
import { MuiClasses } from '../../../types'
import Suggest from '../Steps/Suggest'

const styles = ({ typography }: Theme) => ({
  title: {
    fontSize: typography.pxToRem(32)
  },
  callout: {
    fontWeight: typography.fontWeightBold
  },
  infoText: {
    fontSize: typography.pxToRem(20)
  },
  guaranteeText: {
    marginTop: '37px',
    marginBottom: '39px',
    '@media (min-width: 780px)': {
      marginTop: '75px',
      marginBottom: '66px'
    }
  },
  infoContainer: {
    display: 'flex',
    fontWeight: typography.fontWeightLight,
    marginBottom: '41px'
  },
  tickIcon: {
    marginRight: '13px'
  },
  primaryBtn: {
    height: '82px',
    width: '100%',
    textTransform: 'capitalize' as const,
    fontWeight: typography.fontWeightBold,
    fontSize: '24px',
    '@media (min-width: 780px)': {
      height: '65px'
    }
  },
  buttonContainer: {
    minWidth: '100%',
    justifyContent: 'center' as const,
    margin: '18px 0 72px 0',
    '@media (min-width: 780px)': {
      margin: '53px 0 143px 0'
    }
  },
  fullWidth: {
    width: '100%'
  },
  horizontalPadding4: {
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem'
  },
  verticalPadding: {
    paddingTop: '39px',
    '@media (min-width: 780px)': {
      paddingTop: '70px'
    }
  }
})

type InstantRentCompletePageProps = {
  classes: MuiClasses
  t: TFunction
  apartment: any
}

const InstantRentCompletePage = ({
  classes,
  t,
  apartment
}: InstantRentCompletePageProps) => {
  //  Download PDF
  const handleClickPDF = async () => {
    const data: { media: { url: string | undefined } } = JSON.parse(
      localStorage.getItem('application') || '[]'
    )

    if (data?.media?.url) {
      const w = window.open(data?.media?.url, '_blank')
      if (w) {
        w.focus()
      }
    } else {
      alert(
        'Unable to get generate PDF link. Kindly confirm your network connection'
      )
    }
  }

  return (
    <>
      <>
        <Grid item className={classes.centeredText} xs={12}>
          <CheckCircleIcon size={'107px'} color='#4F9B44' />
        </Grid>

        <Grid
          item
          xs={12}
          className={`${classes.responsiveWidth} ${classes.centeredText}`}
        >
          <Grid item xs={12}>
            <Typography
              variant='body1'
              className={`${classes.title} ${
                isMobile ? classes.my6 : classes.my8
              }`}
            >
              {t('instantRent.instantRentComplete')}
            </Typography>
            <Typography
              variant='body1'
              className={`${classes.callout} ${classes.infoText} ${
                isMobile ? classes.my6 : classes.my8
              }`}
            >
              {t('instantRent.instantRentCompleteCallout')}
            </Typography>

            <Typography
              variant='body2'
              className={`${classes.infoText} ${
                isMobile ? classes.my6 : classes.my8
              }`}
            >
              {t('instantRent.instantRentCompleteInfo')}
            </Typography>

            <button
              style={{
                width: '100%',
                borderRadius: 20,
                background: '#FBF6EE',
                border: 0,
                cursor: 'pointer'
              }}
              onClick={() => handleClickPDF()}
            >
              <Suggest
                suggestContainerStyle={classes.downloadPrompt}
                hideSuggestIcon
                renderText={() => (
                  <Grid
                    container
                    justify='center'
                    alignItems='center'
                    direction={isMobile ? 'column' : 'row'}
                  >
                    <Grid item className={isMobile ? `${classes.mb6}` : ''}>
                      <img src={DownloadIcon} />
                    </Grid>
                    <Grid item>
                      <Typography
                        variant='h6'
                        className={`${classes.centeredText} ${classes.boldText}`}
                      >
                        {t('instantRent.download')}
                      </Typography>
                    </Grid>
                  </Grid>
                )}
                isModal
                customSuggestTextStyles={`${classes.customSuggestTextStyles} ${classes.centeredText}`}
              />
            </button>

            <Typography
              variant='h5'
              className={`${classes.callout} ${classes.infoText} ${
                isMobile ? classes.my6 : classes.my8
              }`}
            >
              {t('instantRent.contactInfoTitle')}
            </Typography>

            <Typography
              variant='body1'
              className={`${classes.callout} ${classes.infoText} ${
                isMobile ? classes.my6 : classes.my8
              }`}
            >
              <Typography variant='body1' className={`${classes.infoText}`}>
                {apartment.companyName}
              </Typography>
              <Typography variant='body1' className={`${classes.infoText}`}>
                {apartment.address}
              </Typography>
              <Typography variant='body1' className={`${classes.infoText}`}>
                Phone: {apartment.phoneNumber}
              </Typography>
              <Typography variant='body1' className={`${classes.infoText}`}>
                Email:{' '}
                <Link href={`mailto:${apartment.loginEmail}`}>
                  {apartment.loginEmail}
                </Link>
              </Typography>
            </Typography>
          </Grid>
        </Grid>
      </>
    </>
  )
}

export default withStyles(styles)(InstantRentCompletePage)
